import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { CopyAllOutlined } from '@mui/icons-material';
import { useCpsiAccessEditor } from '../../../../hooks/useCpsiAccessEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const CpsiCopyPermissionsEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useCpsiAccessEditor(mode);

  const handleChange = (value: string) => {
    updateRequest({ copyPermissionsFrom: value });
  };

  return (
    <TextField
      label="Copy Permissions From"
      value={request?.copyPermissionsFrom || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      placeholder="Enter existing CPSI user ID to copy permissions from"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <CopyAllOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        )
      }}
      helperText="Optional: Specify an existing CPSI user whose permissions should be copied to the new user"
    />
  );
};

export default CpsiCopyPermissionsEditor;
